export default __webpack_public_path__ + "static/media/last_win.e85d0a61.svg";